var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"appRoot"}},[_c('Loading',{staticClass:"zoox-loader",attrs:{"active":_vm.longLoading || _vm.loading}}),(_vm.renderReady)?_c('router-view',{style:(_vm.companyCustomization)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }